// extracted by mini-css-extract-plugin
export var cartIcon = "_ok-0";
export var cartIconContainer = "_ok-1";